import React from 'react';
import { useAuth } from '../contexts/AuthProvider';

const ModuleGuard = ({ moduleKey, children }) => {
  const { capabilities, capabilitiesLoading, hasRole } = useAuth();

  if (capabilitiesLoading) {
    return <div className="d-flex justify-content-center align-items-center p-5"><div className="spinner-border text-primary" role="status" /></div>;
  }

  if (
    hasRole('ROLE_ADMIN') ||
    hasRole('ROLE_DIRECTOR') ||
    hasRole('admin') ||
    hasRole('director')
  ) {
    return children;
  }

  // Only block if the module is explicitly configured with view=false.
  // If the module has no capabilities in DB yet, allow access (not configured = open).
  const moduleCapabilities = capabilities[moduleKey];
  if (moduleCapabilities && moduleCapabilities.view === false) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
        <h3 className="text-muted">Access Denied</h3>
        <p className="text-muted">You do not have permission to view this module.</p>
      </div>
    );
  }

  return children;
};

export default ModuleGuard;
